module.exports = __webpack_public_path__ + "static/kapitola_01_small-74feafb9ca8fc3b3b928b85e08c8ccf3.jpg";